import script from "./BlogEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogEdit.vue?vue&type=script&setup=true&lang=ts"

import "./BlogEdit.vue?vue&type=style&index=0&id=45cbda00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cbda00"]])

export default __exports__